import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { withContent } from '@bubbletea/core';
import { pollWindowVariable } from '@mooncake/mooncake-gateway-ecom/utils';

import GlobalStyles from '../GlobalStyles';
import { fetchCurrentUserSubscription } from '../../features/userSlice';
import { setAnalyticsLoaded } from '../../features/appSlice';
// import isRestricted from '../../utils/isRestricted';

import Hero from '../Sections/Hero';
import KeyFeatures from '../Sections/KeyFeatures';
import About from '../Sections/About';
import Plans from '../Sections/Plans';
import PromoOffers from '../Sections/PromoOffers';
import Reinsurance from '../Sections/Reinsurance';
import MusicGenres from '../Sections/MusicGenres';
import SubscribeTo from '../Sections/SubscribeTo';
import HowTo from '../Sections/HowTo';
import FAQ from '../Sections/FAQ';
import UbiConnectModal from '../Blocks/UbiConnectModal';
import LatestUpdates from '../Sections/LatestUpdates';
import sendEvent from '../../utils/sendEvent';
import { IAdobeProductPageEvent } from '../../types/tracking';
import { IUplayData } from '../../types/module/window';
import { fetchWindowVariables } from '../../features/windowSlice';
import { IContent } from '../../types';

interface IContentProps {
  context: IContent;
}
const Content = ({ context }: IContentProps) => {
  const [playNowModalOpen, setPlayNowModalOpen] = useState(false);
  const dispatch = useDispatch();

  const handleUbiConnectModal = () => {
    const impressionEventDetails = {
      location: 'play on ubisoft connect',
      category: 'display',
      locationPosition: 'pop in',
      action: 'visible',
    };
    sendEvent(impressionEventDetails, 'impressionevent');
    setPlayNowModalOpen(true);
  };
  // const listenToAgeGate = () => {
  //   const targetNode = document.body;
  //   const config = { subtree: false, childList: true };
  //
  //   const observer = new MutationObserver((mutationList: MutationRecord[]) => {
  //     mutationList.forEach((mutation) => {
  //       mutation.addedNodes.forEach((node) => {
  //         const htmlNode = node as HTMLElement;
  //         if (htmlNode.className?.indexOf('age-gate-dialog') > -1) {
  //           document.querySelector('.age-gate-dialog')?.remove();
  //           document.body.classList.remove('is-reveal-open');
  //           document.documentElement.classList.remove('is-reveal-open');
  //           document.getElementById('wrapper')?.removeAttribute('aria-hidden');
  //           document.getElementById('wrapper')?.removeAttribute('inert');
  //           observer.disconnect();
  //         }
  //       });
  //     });
  //   });
  //
  //   observer.observe(targetNode, config);
  //
  //   setTimeout(() => {
  //     observer.disconnect();
  //   }, 20000);
  // };

  useEffect(() => {
    dispatch(fetchWindowVariables(context.googlesheet));
  }, [dispatch]);

  useEffect(() => {
    const productPageEventDetails: IAdobeProductPageEvent = {
      pageName: 'rocksmith plus',
      pageUrl: window.location.href,
      siteSection: process.env['REACT_APP_PAGE_TYPE'] === 'subscriber' ? 'subscriber pages' : 'product pages',
      mdmBrandId: '934',
      mdmInstallmentId: '5257',
      installmentName: 'rocksmith plus',
      brandName: 'rocksmith',
      productId: '5257',
      productName: 'rocksmith plus',
      productSalesType: 'subscription',
      isProdView: 1,
    };
    const initApp = async () => {
      if (window.wa_data) {
        window.wa_data['rocksmithVersion'] = 'subscriber';
      }
      pollWindowVariable('uplayData').then((response: IUplayData) => {
        if (response) {
          productPageEventDetails.ubisoftId = response['user-id'];
        }
        window.addEventListener('message', (event) => {
          if (event.data === 'S_CODE_READY') {
            sendEvent(productPageEventDetails, 'pageevent');
          } else if (event.data === 'PAGEVIEW_EVENT_FIRED') {
            dispatch(setAnalyticsLoaded(true));
          }
        });
      });
      dispatch(fetchCurrentUserSubscription());
      // const isButtonRestricted = await isRestricted();
      // dispatch(setAgeRestricted(isButtonRestricted));

      // listenToAgeGate();
    };
    initApp();
    document.addEventListener('OPEN_UBICONNECT_MODAL', handleUbiConnectModal as EventListener);

    return () => {
      document.removeEventListener('OPEN_UBICONNECT_MODAL', handleUbiConnectModal as EventListener);
      window.removeEventListener('message', (event) => {
        if (event.data === 'S_CODE_READY') {
          sendEvent(productPageEventDetails, 'product pageevent');
        } else if (event.data === 'PAGEVIEW_EVENT_FIRED') {
          dispatch(setAnalyticsLoaded(true));
        }
      });
    };
  }, [dispatch]);

  const pageType = process.env['REACT_APP_PAGE_TYPE'];

  return (
    <>
      <GlobalStyles />
      <Hero />
      {playNowModalOpen ? (
        <UbiConnectModal playNowModalOpen={playNowModalOpen} setPlayNowModalOpen={setPlayNowModalOpen} />
      ) : null}
      {pageType === 'non-subscriber' ? (
        <>
          <KeyFeatures />
          <About />
          <Plans />
          <PromoOffers />
          <Reinsurance />
          <MusicGenres />
          <HowTo />
          <SubscribeTo />
          <FAQ />
        </>
      ) : (
        <>
          <HowTo />
          <LatestUpdates />
          <MusicGenres />
          <KeyFeatures />
          <About />
          <Reinsurance />
          <SubscribeTo />
          <FAQ />
        </>
      )}
    </>
  );
};

export default withContent(Content);
